import { render, staticRenderFns } from "./ChangeField.vue?vue&type=template&id=64d83c7a"
import script from "./ChangeField.vue?vue&type=script&lang=js"
export * from "./ChangeField.vue?vue&type=script&lang=js"
import style0 from "./ChangeField.vue?vue&type=style&index=0&id=64d83c7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports